import { render, staticRenderFns } from "./manageSource.vue?vue&type=template&id=2423f30f&scoped=true&"
import script from "./manageSource.vue?vue&type=script&lang=js&"
export * from "./manageSource.vue?vue&type=script&lang=js&"
import style0 from "./manageSource.vue?vue&type=style&index=0&id=2423f30f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2423f30f",
  null
  
)

export default component.exports